import { Request } from './Request';

export interface IResetServerSettingsParams {
}

export interface IResetServerSettingsResult {
}

export class ResetServerSettingsRequest extends Request<IResetServerSettingsParams, IResetServerSettingsResult> {
  constructor(params: IResetServerSettingsParams = {}) {
    super('resetServerSettings', params);
  }
}
